<script setup>
import { usePageHead } from '@composables/use-page-head'
import Layout from '@layouts/main-layout'

defineProps({
    resource: {
        type: String,
        default: '',
    },
})

defineOptions({ name: 'NotFoundPage' })

usePageHead({
    title: 'Page not found',
    description: `The page you requested could not be found on FRISKY.`,
})
</script>

<template>
    <Layout>
        <h1 class="title">
            404
            <span v-if="resource">
                {{ resource }}
            </span>
            Not Found
        </h1>
    </Layout>
</template>

<style lang="scss" scoped>
.title {
    text-align: center;
}
</style>
